import axiosInstance from "../axiosConfig";
import type {
  KnowledgeBaseCatalogResponse,
  KnowledgeBaseCourse,
  KnowledgeBaseCourseInput,
  KnowledgeBaseLesson,
  KnowledgeBaseStatus,
} from "./knowledgeBaseService.types";

export const fetchKnowledgeBaseCatalog = async (search = ""): Promise<KnowledgeBaseCatalogResponse> => {
  const response = await axiosInstance.get<KnowledgeBaseCatalogResponse>("/courses/knowledge-base/", {
    params: search.trim() ? { search: search.trim() } : undefined,
  });
  return response.data;
};

export const fetchKnowledgeBaseStatus = async (): Promise<KnowledgeBaseStatus> => {
  const response = await axiosInstance.get<KnowledgeBaseStatus>("/courses/knowledge-base/status/");
  return response.data;
};

export const fetchKnowledgeBaseCourse = async (courseId: number): Promise<KnowledgeBaseCourse> => {
  const response = await axiosInstance.get<KnowledgeBaseCourse>(`/courses/knowledge-base/${courseId}/`);
  return response.data;
};

export const fetchKnowledgeBaseLessons = async (courseId: number): Promise<KnowledgeBaseLesson[]> => {
  const response = await axiosInstance.get<KnowledgeBaseLesson[]>(`/courses/knowledge-base/${courseId}/lessons/`);
  return response.data;
};

export const fetchKnowledgeBaseLesson = async (
  courseId: number,
  lessonId: number,
): Promise<KnowledgeBaseLesson> => {
  const response = await axiosInstance.get<KnowledgeBaseLesson>(
    `/courses/knowledge-base/${courseId}/lessons/${lessonId}/`,
  );
  return response.data;
};

export const createKnowledgeBaseCourse = async (
  input: KnowledgeBaseCourseInput,
): Promise<KnowledgeBaseCourse> => {
  const response = await axiosInstance.post<KnowledgeBaseCourse>("/courses/", {
    ...input,
    price: "0",
    is_knowledge_base: true,
  });
  return response.data;
};

export const updateKnowledgeBaseCourse = async (
  courseId: number,
  input: Partial<KnowledgeBaseCourseInput> & { is_approved_by_admin?: boolean },
): Promise<void> => {
  await axiosInstance.patch(`/courses/${courseId}/`, input);
};

export const deleteKnowledgeBaseCourse = async (courseId: number): Promise<void> => {
  await axiosInstance.patch("/courses/set_deleted/" + courseId + "/");
};